module.exports = __webpack_public_path__ + "static/media/Read-Light_V1100.f980e257.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Light_V1100.eot
// module id = 921
// module chunks = 0